import { AllocationRule } from 'further-types/lp/allocations';
import { ActionRef } from 'further-types/lp/action';
import { z } from 'zod';
import CalendarDay from '../../../utils/calendar-day';
import isMongoId from '../../helpers/is-mongo-id';

const RealisationAllocationSchema = z.object({
  holdingClassId: z.string().refine(isMongoId()),
  commitmentId: z.string().refine(isMongoId()),
  investmentId: z.string().refine(isMongoId()),
  investorLabel: z.string(),
  allocationPercentage: z.number(),
  originalAllocationPercentage: z.number(),
  allocationType: z.nativeEnum(AllocationRule),
  receivedConsiderationLcy: z.number(),
  earnoutConsiderationLcy: z.number(),
  escrowConsiderationLcy: z.number(),
  withholdingTaxPayableLcy: z.number(),
  withholdingTaxExempt: z.boolean(),
  excludeFromAllocation: z.boolean().optional(),
  unitsAllocated: z.number(),
});

export const AllocationSchema = z.object({
  _id: z.string().optional(),
  investorLabel: z.string(),
  commitmentId: z.string().refine(isMongoId()),
  totalCommitmentLcy: z.number(),
  unallocatedCommitmentLcy: z.number(),
  recallableDistributionLcy: z.number(),
  availableToBeCalledLcy: z.number(),
  closeDate: z.date(),
  paidAmountLcy: z.number().optional(),
  unpaidAllocationAmountLcy: z.number().optional().nullable(),
  allocationAmountLcy: z.number(),
  allocationPercentage: z.number(),
  excludeFromAllocation: z.boolean(),
  allocationRule: z.nativeEnum(AllocationRule),
});

export const LinkedActionSchema = z.object({
  actionId: z.string(),
  actionRef: z.nativeEnum(ActionRef),
  counterpartyLabel: z.string(),
  ledgerDate: z.instanceof(CalendarDay),
  totalAmountLcy: z.number(),
  originalAllocations: z.array(AllocationSchema).optional(),
  newAllocations: z.array(AllocationSchema),
  allocationRule: z.nativeEnum(AllocationRule),
  originalRealisationAllocations: z
    .array(RealisationAllocationSchema)
    .optional(),
  newRealisationAllocations: z.array(RealisationAllocationSchema).optional(),
  newRealisationAllocationTotals: z.object({
    totalReceivedConsiderationLcy: z.number(),
    totalEarnoutLcy: z.number(),
    totalEscrowLcy: z.number(),
    totalWithholdingTaxLcy: z.number(),
    totalUnits: z.number(),
  }),
});
